import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsForm({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M10.4 2h.6c.83 0 1.5.67 1.5 1.5v1.38L7.47 9.92a.52.52 0 00-.11.16l-.03.09-.64 2.68a.53.53 0 00.54.64l.1-.01 2.8-.68a.52.52 0 00.18-.08l.07-.06 2.12-2.12v1.96c0 .83-.67 1.5-1.5 1.5H3a1.5 1.5 0 01-1.5-1.5v-9C1.5 2.67 2.17 2 3 2h.6v.9a1 1 0 00.88 1H9.4a1 1 0 001-.88V2zm-1.99 8.36l1.42 1.42-.28.28-1.38.32a.3.3 0 01-.35-.36l.31-1.37.28-.29zm3.54-3.53l1.41 1.41-3.04 3.04-1.41-1.41 3.04-3.04zm1.63-1.2l.99.99a.3.3 0 010 .42l-.71.7-1.42-1.4.71-.71a.3.3 0 01.43 0zM9 1c.28 0 .5.22.5.5v1A.5.5 0 019 3H5a.5.5 0 01-.5-.5v-1c0-.28.22-.5.5-.5h4z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsForm.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsForm.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgSettingsForm svgRef={ref} {...props} />);
export default ForwardRef;
